// All characters are left-facing
export const themes = [
  {
    // 0 - blobby pink character
    src: 'https://d16qt3wv6xm098.cloudfront.net/pA2PwoDGT9Of5u5sXUYVsgVZSxyFsFiY/_.png',
    theme: 'pink',
  },
  {
    // 1 - red blood cell (aged)
    src: 'https://d16qt3wv6xm098.cloudfront.net/UAoi90hQQm_84TliJsXtjlPKSDqrlc8m/_.png',
    theme: 'red',
  },
  {
    // 2 - purple lymphocyte
    src: 'https://d16qt3wv6xm098.cloudfront.net/24X4RKqSTX6CwLbGudaTR2cmQGSthbxS/_.png',
    theme: 'purple',
  },
  {
    // 3 - lungs
    src: 'https://d16qt3wv6xm098.cloudfront.net/ruVCQDfTSzukkaEbP7D5c-FWT7CIeJLn/_.png',
    theme: 'blue',
  },
  {
    // 4 - kidney
    src: 'https://d16qt3wv6xm098.cloudfront.net/dITHVTuVTCqYaJDtVxD8_yiSSYq-EA7o/_.png',
    theme: 'pink',
  },
  {
    // 5 - blue lymphocyte
    src: 'https://d16qt3wv6xm098.cloudfront.net/dJ0uoMeSRqmN_DQnlqVsUFceSeugqn24/_.png',
    theme: 'blue',
  },
  {
    // 6 - osteoblast
    src: 'https://d16qt3wv6xm098.cloudfront.net/pRIt9T8bSu_dG45aQYqPKCqpQ5C224r0/_.png',
    theme: 'teal',
  },
  {
    // 7 - epithelial
    src: 'https://d16qt3wv6xm098.cloudfront.net/37kGdX6ESAi9Z-GsTSGOl38gSkei1mia/_.png',
    theme: 'pink',
  },
  {
    // 8 - spleen
    src: 'https://d3cdo0emj8d2qc.cloudfront.net/assets/0JVnIydKQ__3t9k670L6ggJKTe_x6toP.png',
    theme: 'pink',
  },
  {
    // 9 - eggs
    src: 'https://d16qt3wv6xm098.cloudfront.net/nIAyz_5VSjmKMjMX5vA6898aR_WrhqdS/_.png',
    theme: 'pink',
  },
  {
    // 10 - gallbladder
    src: 'https://d16qt3wv6xm098.cloudfront.net/l8Ts2-dmSJi4Pese0dXJKwabTyS2pIWH/_.png',
    theme: 'green',
  },
  {
    // 11 - stomach
    src: 'https://d16qt3wv6xm098.cloudfront.net/TucnEJH9TOa94xRs-Ha5AoB9TIiFMHHD/_.png',
    theme: 'pink',
  },
];
